import React from 'react';
import propTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'src/ui/mui-ui-kit';;
import classNames from 'classnames';

export function NextButton({ to, onClick, disabled, children, isPrev }) {
  if (!to && !onClick) {
    throw new Error('You must provide either `to` or `onClick`.');
  }
  const wrapperClassName = classNames('bottom-next-button', {
    'has-text-right': !isPrev,
  });

  if (to) {
    return (
      <div className={wrapperClassName}>
        <NavLink to={to} className="button is-gradient-bright">
          {isPrev && (
            <span className="icon is-left">
              <FontAwesomeIcon icon={['fal', 'arrow-left']} />
            </span>
          )}
          <span>{children}</span>
          {!isPrev && (
            <span className="icon is-right">
              <FontAwesomeIcon icon={['fal', 'arrow-right']} />
            </span>
          )}
        </NavLink>
      </div>
    );
  }
  return (
    <div className={wrapperClassName}>
      <Button isColor="gradient-bright" onClick={onClick} disabled={disabled}>
        {isPrev && (
          <span className="icon is-left">
            <FontAwesomeIcon icon={['fal', 'arrow-left']} />
          </span>
        )}
        <span>{children}</span>
        {!isPrev && (
          <span className="icon is-right">
            <FontAwesomeIcon icon={['fal', 'arrow-right']} />
          </span>
        )}
      </Button>
    </div>
  );
}

NextButton.defaultProps = {
  to: null,
  onClick: null,
  disabled: false,
  children: 'Next',
  isPrev: false,
};

NextButton.propTypes = {
  to: propTypes.string,
  onClick: propTypes.func,
  disabled: propTypes.bool,
  children: propTypes.oneOfType([propTypes.node, propTypes.element]),
  isPrev: propTypes.bool,
};
